import type { ReceiptTemplate } from '../schema';

export const advanceAutoPartsTemplate: ReceiptTemplate = {
  id: 'advance-auto-parts',
  name: 'Advance Auto Parts Receipt',
  brand: 'ADVANCE AUTO PARTS',
  description: 'Advance Auto Parts store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'aap-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/advance-auto-parts.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 14,
        addressLines: [
          'STORE #4892',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'aap-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Trans:', value: '847291' },
        ],
        column2: [
          { id: 'date', label: '', value: '01/04/2026 2:45PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'aap-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'MOTOR OIL 5QT', quantity: '1', price: '32.99', sku: '847291034' },
          { id: '2', name: 'OIL FILTER', quantity: '1', price: '8.99', sku: '847291035' },
          { id: '3', name: 'AIR FILTER', quantity: '1', price: '19.99', sku: '847291036' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'aap-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '61.97', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '5.11', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '67.08', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'aap-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'aap-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'SPEED PERKS MEMBER\n\nReturns within 45 days\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

